import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription, fromEvent } from 'rxjs';
import { ErrorService } from '../../services/error.service';
import { ITransaction, SaleService } from '../../services/sale.service';
import { Sale } from '../../models/sale.model';

@Component({
  selector: 'article-search-list',
  templateUrl: './article-search-list.component.html',
  styleUrls: ['./article-search-list.component.scss'],
})
export class ArticleSearchListComponent implements OnInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;

  public currentArray: Sale[] = [];
  private _dataStream: BehaviorSubject<Sale[]> = new BehaviorSubject<
    Sale[]
  >([]);
  public dataStream$: Observable<Sale[]> =
    this._dataStream.asObservable();
  public theEnd = false;
  public loading = false;
  private _firstLoad = true;
  private _subscriptions = new Subscription();

  constructor(
    private _saleService: SaleService,
    private _router: Router,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    if (this._saleService.sales.length > 0) {
      this.currentArray = this._saleService.sales;
      this._dataStream.next(this.currentArray);
    } else {
      this._errorService.showError('errors.noTransaction');
      this._router.navigateByUrl(`/client-search`);
    }
  }

  ngAfterViewInit(): void {
    if(this.viewport) {
      this._subscriptions.add(fromEvent(this.viewport.elementRef.nativeElement,'scroll')
      .subscribe((e: Event) => 
        this._saleService.salesListYAxis = e.target['scrollTop']
      ));
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public nextBatch(): void {
    if (
      !this.loading &&
      !this.theEnd &&
      this.viewport &&
      this.viewport.getRenderedRange().end === this.viewport.getDataLength()
    )
      this.getBatch();
    if(this._firstLoad && this.viewport) {
      this._firstLoad = false;
      this.viewport.scrollTo({top: this._saleService.salesListYAxis});
    }
  }

  public transactionClicked(sale: Sale): void {
    this._saleService.selectedSale = sale;
    const trnDate = sale.transactions[0].transactionDate.replace(/-/g,"");
    this._router.navigateByUrl(
      `/transaction/${sale.transactions[0].id}/${sale.transactions[0].registerId}/${sale.transactions[0].locationId}/${trnDate}`
    );
  }

  public getItemColour(transaction: ITransaction): string[] {
    const matchedItems = transaction.items.filter((item) => item.genericId === this._saleService.articleId);
    return matchedItems.length > 3 ? ['Multiple'] : matchedItems.map((item) => item.colour);
  }

  public getItemSize(transaction: ITransaction): string[] {
    const matchedItems = transaction.items.filter((item) => item.genericId === this._saleService.articleId);
    return matchedItems.length > 3 ? ['Multiple'] : matchedItems.map((item) => item.size);
  }

  private getBatch(): void {
    if (this.currentArray.length > 0 && this.currentArray.length < this._saleService.totalSales){
      this.loading = true;
      this._subscriptions.add(
        this._saleService.getNextArticles().subscribe(() => {
        this.loading = false;
      }));
    }
    if (this.currentArray.length >= this._saleService.totalSales){
      this.theEnd = true;
    }
  }
}
